export default __webpack_public_path__ + "static/media/arrow.e3655408.svg";